import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/ProfileSettingsCard/index.js';
import RegionSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/RegionSettingsCard';
import ThemeSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/ThemeSettingsCard';
import EmailSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/EmailSettingsCard/EmailSettingsCard';
// import PasswordSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/PasswordSettingsCard';
import TwoFactorAuthSettingsCardComponent from '@t7x000/apex-web/lib/components/Settings/ProfileAndSecurity/TwoFactorAuthSettingsCard';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './UserSettingsPage.css';

const userSettingsPageClasses = getBEMClasses('user-settings-page');

const UserSettingsPage = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={userSettingsPageClasses('container')}>
        <div className={userSettingsPageClasses('page-header')}>
          <h1 className={userSettingsPageClasses('title')}>{t('Update Profile and Security Settings.')}</h1>
          <h2 className={userSettingsPageClasses('sub-title')}>
            {t(' Here you can make general settings such as...')}
          </h2>
        </div>
        <div className={userSettingsPageClasses('row')}>
          <ProfileSettingsCardComponent />
          <RegionSettingsCardComponent />
        </div>

        <div className={userSettingsPageClasses('row', 'sm')}>
          <ThemeSettingsCardComponent />
          <EmailSettingsCardComponent />
        </div>

        <div className={userSettingsPageClasses('row', 'sm')}>
          <TwoFactorAuthSettingsCardComponent />
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserSettingsPage;
